// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.htmlContent[data-v-69fc949d] {\n  max-height: 400px;\n  overflow: auto;\n}\n.htmlContent[data-v-69fc949d] img {\n  display: block;\n  max-width: 100%;\n  max-height: 300px;\n}\n", ""]);
// Exports
module.exports = exports;
